<template>
  <v-app id="inspire"> <!-- :class="($route.name == 'Login' ? 'bg-image' : '')" id="inspire" -->
    <v-overlay :value="overlay" z-index="999999">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
    <router-view/>
  </v-app>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'main-app',
  created() {
    let user = JSON.parse(localStorage.getItem('user'));
    if(user) {
      this.setUser(user);
      this.setPermissions(user.user.roles[0].permissions);
      this.$router.replace({
        name: 'Dashboard'
      })
    }
  },
  computed: {
    ...mapGetters({
      overlay: 'overlay'
    })
  },
  methods: {
    ...mapMutations({
      setUser: 'auth/SET_USER',
      setPermissions: 'auth/SET_PERMISSIONS',
    })
  }
}

</script>
